import { Injectable } from '@angular/core';
import { PersonaType } from '@models/persona-type';
import { insertIf } from '@util/insert-if';
import { MenuItem } from 'primeng/api';
import { combineLatest } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { CurrentUserService } from './current-user.service';
import { UsersService } from './users.service';

@Injectable({
  providedIn: 'root'
})
export class UserMenusService {
  personaMenu$ = this.currentUserService.user$.pipe(
    map((user) => {
      return <MenuItem[]>[
        {
          label: `persona.${PersonaType[user.persona.toUpperCase()]}`,
          items: [
            ...insertIf<MenuItem>(
              user,
              ...insertIf<MenuItem>(user.persona !== PersonaType.LEARNER, {
                label: 'organizations',
                routerLink: '/organizations',
                icon: 'fa fa-fw fa-sitemap'
              }),
              ...insertIf<MenuItem>(user?.can?.vend, {
                label: 'theming',
                routerLink: '/theming',
                icon: 'fa fa-fw fa-palette'
              })
            )
          ]
        }
      ];
    })
  );

  userMenu$ = this.currentUserService.user$.pipe(
    map((user) => {
      return [
        ...insertIf<MenuItem>(user, {
          label: user.fullName,
          items: [
            {
              label: 'my-orders',
              routerLink: ['user', 'orders'],
              icon: 'fa fa-fw fa-receipt'
            },
            {
              label: 'my-account',
              routerLink: ['user', 'account'],
              icon: 'fa fa-fw fa-cog'
            },
            {
              label: 'public-profile',
              command: (event) => window.open(`${window.location.origin}/users/${user.id}`, '_blank'),
              icon: 'fa fa-fw fa-external-link'
            },
            ...insertIf<MenuItem>(user.can.visitClassic, {
              label: 'back-to-classic',
              url: '/app',
              icon: 'fa fa-fw fa-computer-classic'
            }),
            { separator: true },
            {
              label: 'logout',
              command: (event) => this.onLogOut(user.id),
              icon: 'fa fa-fw fa-sign-out'
            }
          ]
        })
      ];
    })
  );

  sidebarMenu$ = this.currentUserService.user$.pipe(
    map((user) => {
      return [
        ...insertIf<MenuItem>(
          user.can.visitClassic,
          { separator: true },
          {
            label: 'back-to-classic',
            url: '/app',
            icon: 'fa fa-fw fa-computer-classic'
          }
        ),
        { separator: true },
        {
          label: 'logout',
          command: (event) => this.onLogOut(user.id),
          icon: 'fa fa-fw fa-sign-out'
        }
      ];
    })
  );

  menu$ = combineLatest([this.personaMenu$, this.userMenu$]).pipe(
    map((menus) => menus.reduce((items, menu) => items.concat(menu), [])),
    shareReplay(1)
  );

  constructor(private currentUserService: CurrentUserService, private usersService: UsersService) {}

  private onLogOut(id: number) {
    this.usersService.logout({ id }).subscribe((url) => {
      if (!url) {
        return;
      }

      window.location.replace(url);
    });
  }
}
